var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns", attrs: { id: _vm.id } },
    _vm._l(_vm.children, function(child, index) {
      return _c(
        "div",
        {
          key: child.id,
          staticClass: "columns__column",
          class: _vm.getColumnWidthStyle(index),
          attrs: { id: _vm.id + "__column" + index }
        },
        [
          index !== 0
            ? _c("column-separator", {
                staticClass: "resizable__handle",
                attrs: { columnId: _vm.id, index: index },
                on: { resize: _vm.updateItemSizes }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_vm.getComponentVue(child.id), {
            tag: "component",
            attrs: { id: child.id }
          })
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }